<!-- Shared provider header (name, enabled and discovery badges, meta, Disable/Enable) + Feeds | Details tabs.
     The type shell projects its <router-outlet> as content. -->
<ng-container *transloco="let t; read: 'providers.detailPage'">
  <div class="flex h-full min-h-0 flex-col">
    <!-- Header: name + status, meta line, Disable / Add feed actions -->
    <div class="flex flex-none flex-wrap items-start justify-between gap-4">
      <div class="flex flex-col gap-2">
        <div class="flex items-center gap-3.5">
          <h1 class="m-0 font-display text-2xl font-bold text-ink-1">{{ provider()?.name ?? t('dash') }}</h1>
          @if (provider(); as p) {
            <app-label-badge [dot]="p.enabled ? 'green' : null">{{ p.enabled ? t('status.enabled') : t('status.disabled') }}</app-label-badge>
            <app-label-badge [dot]="discoveryDot()" [title]="p.lastDiscoveryError ?? ''">{{ discoveryLabel() }}</app-label-badge>
          }
        </div>
        @if (provider(); as p) {
          <div class="flex flex-wrap items-center gap-x-6 gap-y-1.5 text-[13px] text-ink-3">
            <span>{{ t('meta.serviceUrl') }} <span class="text-ink-1">{{ p.serviceUrl }}</span></span>
            @if (p.providerVersion) {
              <span>{{ t('meta.version') }} <span class="text-ink-1">{{ p.providerVersion }}</span></span>
            }
            <span>{{ t('meta.feeds') }} <span class="text-ink-1">{{ t('meta.feedsAcrossTenants', { count: feeds().length, tenants: tenantCount() }) }}</span></span>
            <span>{{ t('meta.created') }} <span class="text-ink-1">{{ p.createdAt | date: 'mediumDate' }}</span></span>
          </div>
        }
      </div>
      @if (provider(); as p) {
        <div class="flex flex-none items-center gap-2.5 pt-0.5">
          <button
            type="button"
            (click)="toggleEnabled()"
            class="rounded-control border border-hairline bg-card px-4 py-2.5 text-[14px] font-semibold text-ink-1 hover:bg-sunken"
          >
            {{ p.enabled ? t('actions.disable') : t('actions.enable') }}
          </button>
        </div>
      }
    </div>

    <!-- Feeds | Details tab strip (routed content below) -->
    <div class="mt-3.5 flex flex-none items-stretch gap-1 border-b border-hairline">
      @for (tabId of ['feeds', 'details']; track tabId) {
        <button
          type="button"
          (click)="showTab($any(tabId))"
          class="relative flex items-center gap-2 border-none bg-transparent px-4 py-3"
        >
          <span
            class="text-[13px] font-bold uppercase tracking-wide"
            [class.text-ink-1]="activeTab() === tabId"
            [class.text-ink-3]="activeTab() !== tabId"
            >{{ t('tabs.' + tabId) }}</span
          >
          @if (tabId === 'feeds') {
            <span
              class="inline-flex min-w-5 items-center justify-center rounded-full px-1.5 py-0.5 text-[11px] font-semibold"
              [class.bg-ink-1]="activeTab() === 'feeds'"
              [class.text-card]="activeTab() === 'feeds'"
              [class.bg-sunken]="activeTab() !== 'feeds'"
              [class.text-ink-2]="activeTab() !== 'feeds'"
              >{{ feeds().length }}</span
            >
          }
          @if (activeTab() === tabId) {
            <div class="absolute inset-x-3 -bottom-px h-0.5 rounded bg-action"></div>
          }
        </button>
      }
    </div>

    <div class="min-h-0 flex-1">
      <ng-content />
    </div>
  </div>
</ng-container>
